<template lang="pug">
.container
  el-form.select-deviceTagsPlayDependency(v-if='medium && currentUserNetwork.playTagDependancyUsed')
    el-form-item(:label='$t("Require matching device tags to play:")', size='mini')
      el-select(id="MediumTagsEditor-deviceTagsPlayDependency" v-model='medium.deviceTagsPlayDependency', @change="deviceTagsPlayDependencyChangeHandler")
        el-option(
          v-for="deviceTagsPlayDependencyOption of deviceTagsPlayDependencyOptions",
          :key="deviceTagsPlayDependencyOption",
          :label="$t(deviceTagsPlayDependencyOption)",
          :value="deviceTagsPlayDependencyOption",
          v-bind:id="'deviceTagsPlayDependencyOption' + deviceTagsPlayDependencyOption"
        )
      span.saving-tag(:class="{ visible: savingNetworkTag }") &nbsp;
        font-awesome-icon.fa-spin(icon="sync")
  .items-container
    el-select(
      v-model='selectedMediaTags',
      id="MediumTagsEditorDropdown-select",
      multiple,
      filterable,
      allow-create,
      :placeholder='$t("Select tags for medium")')
      el-option(v-for='tag in allTags' :key='tag.id' :label='tag.name' :value='tag.id', :id="'MediumTagsEditorDropdown-option' + tag.id")
</template>

<script>
import Vue from 'vue'
import userUtils from '../Common/userUtils.mixin'

export default {
  props: ['mediumId'],
  mixins: [userUtils],
  created () {
    this.medium = JSON.parse(JSON.stringify(this.$store.state.Medium.media_list.find(medium => {
      return medium.id === this.mediumId
    })))
    this.selectedMediaTags = this.mediumTags.map(dt => dt.id)
  },
  watch: {
    async selectedMediaTags (newValue, oldValue) {
      if (!this.selectedMediaTags || !oldValue) return
      this.savingNetworkTag = true
      if (newValue.findIndex(tagId => isNaN(tagId)) > -1) {
        const newTag = await this.$store.dispatch('Device/addMediumTag', newValue.find(tagId => isNaN(tagId)))
        newValue.splice(newValue.findIndex(tagId => isNaN(tagId)), 1)
        newValue.push(newTag.id)
      }
      await this.$store.dispatch('Medium/replaceMediumTagsInMedium', [newValue.filter(tagId => !isNaN(tagId)), this.medium.id])
      this.savingNetworkTag = false
    }
  },
  data () {
    return {
      errors: {
      },
      selectedMediaTags: undefined,
      deviceTagsPlayDependencyOptions: ['none', 'all', 'any'],
      savingNetworkTag: false
    }
  },
  methods: {
    // FIXME DRY
    async deviceTagsPlayDependencyChangeHandler () {
      this.savingNetworkTag = true
      await Vue.axios.patch('medium/' + this.medium.id, {
        id: this.medium.id,
        deviceTagsPlayDependency: this.medium.deviceTagsPlayDependency
      })
      this.savingNetworkTag = false
    }
  },
  computed: {
    allTags () {
      return [...this.mediumTags, ...this.unusedNetworktagsInMedium]
    },
    unusedNetworktagsInMedium () {
      if (!this.medium) return this.$store.state.Medium.medium_tags
      const unusedTagsInMedium = []
      for (let index = 0; index < this.$store.state.Medium.media_tags.length; index++) {
        const element = this.$store.state.Medium.media_tags[index]
        const mediumTagUsedInMedium = this.mediumTags.findIndex(mediumTag => mediumTag.id === element.id)
        if (mediumTagUsedInMedium === -1) unusedTagsInMedium.push(element)
      }
      const allunusedTagsInMedium = JSON.parse(JSON.stringify(this.$store.state.Medium.media_tags_unused))
      for (const unusedTagInMedium of unusedTagsInMedium) {
        if (!allunusedTagsInMedium.find(dt => dt.id === unusedTagInMedium.id)) {
          allunusedTagsInMedium.push(unusedTagInMedium)
        }
      }
      const tagsSorted = allunusedTagsInMedium.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      return tagsSorted
    },
    mediumTags () {
      if (!this.medium) return []
      console.log(this.$store.state.Medium.media_tags)
      const tagsSorted = this.$store.state.Medium.media_tags.filter(mt => mt.media.includes(this.medium.id)).sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      return tagsSorted
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.saving-tag {
  opacity: 0;
  &.visible {
    opacity: 1;
  }
}
.items-container {
  display: flex;
  flex-direction: column;
  .deviceTagsUsed, .unusedTags {
    display: inline-flex;
    border: 0px solid red;
    flex-wrap: wrap;
    justify-content: flex-start;
    .no-tags-warning {
      margin-right: 20px;
      color: $--color-text-secondary;
    }
  }
  .deviceTags {
    border-bottom: $--border-light;
    padding: 0px 0px 0px 0px;
    margin-bottom: 10px;
    &.tags-used {
      margin-top: 10px;
    }
    .tag, button {
      margin: 0px 10px 10px 0px;
      background-color: rgba($--color-primary, 0.6);
      border: 1px solid rgba(black, 0.8);
      border-radius: 5px;
    }
    .tag-unused {
      opacity: 0.5;
      color: #fff;
    }
    button {
      margin: 0px 10px 10px 0px;
    }
    .input-new-tag {
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediumTagsEditorDropdown.vue